const CODE_MESSAGES = {
  'auth/invalid-credential': 'Wrong email or password combination.',
  'auth/wrong-password': 'Wrong email or password combination.',
  'auth/user-not-found': 'Wrong email or password combination.',
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/user-disabled': 'This account is not available. Contact an administrator.',
  'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
  'auth/network-request-failed': 'Unable to connect. Check your connection and try again.',
  'auth/email-already-in-use': 'This email is already registered.',
  'auth/weak-password': 'That password is too weak. Choose a stronger password.',
  'auth/requires-recent-login': 'Please sign in again and retry.',
  'functions/already-exists': 'This email is already registered.',
  'functions/permission-denied': 'You do not have permission to do that.',
  'functions/unauthenticated': 'Please sign in and try again.',
  'functions/resource-exhausted': 'Please wait a few minutes and try again.',
  'functions/not-found': 'We could not find that record.',
  'functions/invalid-argument': 'Some of the information provided is not valid.',
  'functions/unavailable': 'Unable to connect. Check your connection and try again.',
  'permission-denied': 'You do not have permission to do that.',
  'unavailable': 'Unable to connect. Check your connection and try again.'
};

const TECHNICAL_MESSAGE = /firebase|auth\/|functions\/|cloudfunctions|internal error|native error/i;

/**
 * Turn a caught error into copy that is safe to show in the UI.
 * Firebase codes and SDK wording stay in the console, not on screen.
 */
export function toUserMessage(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) return fallback;

  const code = String(error.code || '').toLowerCase();
  const raw = (typeof error === 'string' ? error : String(error.message || '')).trim();
  const technical = TECHNICAL_MESSAGE.test(raw);

  if (!technical && raw) return raw;

  const embedded = raw.match(/\((auth\/[a-z0-9-]+|functions\/[a-z0-9-]+)\)/i);
  const embeddedCode = embedded ? embedded[1].toLowerCase() : '';
  if (CODE_MESSAGES[code]) return CODE_MESSAGES[code];
  if (CODE_MESSAGES[embeddedCode]) return CODE_MESSAGES[embeddedCode];

  return fallback;
}
